import { gql, TypedDocumentNode } from "@apollo/client";

import { WebhooksIntegration, WebhooksIntegrationInput } from "types/generated";

type CreateWebhookIntegrationForModuleData = {
  webhooksIntegrationCreate: Pick<WebhooksIntegration, "id">;
};

type CreateWebhookIntegrationForModuleVariables = {
  moduleId: string;
  input: WebhooksIntegrationInput;
};

export const CREATE_WEBHOOK_INTEGRATION: TypedDocumentNode<
  CreateWebhookIntegrationForModuleData,
  CreateWebhookIntegrationForModuleVariables
> = gql`
  mutation CreateWebhookIntegrationForModule($moduleId: ID!, $input: WebhooksIntegrationInput!) {
    webhooksIntegrationCreate(stack: $moduleId, input: $input) {
      id
    }
  }
`;

type UpdateWebhookIntegrationForModuleData = {
  webhooksIntegrationUpdate: Pick<WebhooksIntegration, "id">;
};

type UpdateWebhookIntegrationForModuleVariables = {
  id: string;
  moduleId: string;
  input: WebhooksIntegrationInput;
};

export const UPDATE_WEBHOOK_INTEGRATION: TypedDocumentNode<
  UpdateWebhookIntegrationForModuleData,
  UpdateWebhookIntegrationForModuleVariables
> = gql`
  mutation UpdateWebhookIntegrationForModule(
    $id: ID!
    $moduleId: ID!
    $input: WebhooksIntegrationInput!
  ) {
    webhooksIntegrationUpdate(id: $id, stack: $moduleId, input: $input) {
      id
    }
  }
`;
